import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-content">
          <div className="legal-header">
            <h1 className="legal-title">Terms of Use</h1>
            <p className="legal-subtitle">Effective Date: September 1, 2025</p>
          </div>

          <div className="legal-section">
            <p>
              Please read these Terms of Use carefully. By accessing the Peak Risk Management, LLC website ("Site"), you agree to be bound by the terms and conditions outlined below. These Terms may be updated or modified at any time without prior notice. Continued use of the Site constitutes acceptance of any changes.
            </p>
          </div>

          <div className="legal-section">
            <h2>Intellectual Property</h2>
            <p>
              All content, materials, and design elements on this Site—including text, graphics, logos, icons, software, and documents—are the property of Peak Risk Management, LLC or its licensors and are protected by applicable intellectual property laws.
            </p>
            <p>
              No content from this Site may be copied, reproduced, republished, uploaded, posted, transmitted, or distributed in any way without the prior written consent of Peak Risk Management, LLC.
            </p>
            <p>
              Accessing this Site does not grant you any ownership or license rights to any intellectual property contained herein.
            </p>
          </div>

          <div className="legal-section">
            <h2>Disclaimer of Warranties</h2>
            <p>
              The information and materials provided on this Site are offered "as is" and "as available," without warranties of any kind, either express or implied.
            </p>
            <p>
              Peak Risk Management, LLC makes no representations or warranties regarding the accuracy, completeness, reliability, or suitability of the content for any purpose. We expressly disclaim all warranties, including but not limited to merchantability, fitness for a particular purpose, and non-infringement.
            </p>
          </div>

          <div className="legal-section">
            <h2>Limitation of Liability</h2>
            <p>
              In no event shall Peak Risk Management, LLC be liable for any direct, indirect, incidental, special, consequential, or exemplary damages arising out of or in connection with your use of the Site or reliance on its content. This includes, but is not limited to, loss of profits, data, goodwill, or business opportunities—even if advised of the possibility of such damages.
            </p>
            <p>
              Use of this Site is at your own risk.
            </p>
          </div>

          <div className="legal-section">
            <h2>Third-Party Links</h2>
            <p>
              This Site may contain links to third-party websites for convenience or informational purposes. Peak Risk Management, LLC does not endorse, control, or assume responsibility for the content, policies, or practices of any third-party sites.
            </p>
            <p>
              Visiting linked sites is at your own discretion and subject to the terms and policies of those sites.
            </p>
          </div>

          <div className="legal-section">
            <h2>Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of Arizona, without regard to its conflict of law principles.
            </p>
          </div>

          <div className="legal-contact">
            {/* <h2>Contact Us</h2> */}
            <p>
              If you have any questions about these Terms of Use, please contact us at:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:support@peakrmis.com">support@peakrmis.com</a><br />
              <strong>Company:</strong> Peak Risk Management, LLC
            </p>
          </div>

          <div className="legal-back-button">
            <Link to="/" className="btn btn-primary">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
